import Heading from './Heading';
import Nav from './Nav';
import NavItem from './NavItem';
import MegaMenu from './MegaMenu';
import {dropMenu} from '../styles';

const DropMenu = ( {menuId, title, className, style = {}, children} ) =>
    <div id={menuId}
         style={style}
         className={[dropMenu.root, className].join( ' ' )}>
            {children}
    </div>

DropMenu.heading = Heading;
DropMenu.nav = Nav;
DropMenu.navItem = NavItem;
DropMenu.megaMenu = MegaMenu;

export default DropMenu;